import axiosInstance from "./axiosInstance";

export const demoStockListing = async () => {
  const { data } = await axiosInstance.get("/demo/stock-listing");

  return data;
};

export const demoSingleStock = async (symbol) => {
  const { data } = await axiosInstance.get("/demo/stock/" + symbol);

  return data;
};
  